<template>
<!-- 移动端 -->
<div class="mains-page">
  <div class="industry">
    <!-- | Series Products -->
  <p class="indestry-lif">{{res1}}</p>
  <p class="indestry-w">Why choose us</p>
</div>
<div class="indus">
  <!-- <p class="indus-chan">产品简介  <span> Product introduction</span></p>
  <p class="i-p">{{res2}}{{res3}}</p> -->
  <p class="indus-chan1">案例简介  <span> Case introduction</span></p>
  <p class="i-p">{{res4}}</p>
</div>
<img class="kongpai" src="../assets/edit/tlf_qyltdn_kphybs.png" alt="">
</div>
</template>
<script>
export default {
  props: {
    res1: {
      type: String,
      default: ''
    },
    res2: {
      type: String,
      default: ''
    },
    res3: {
      type: String,
      default: ''
    },
    res4: {
      type: String,
      default: ''
    },
    res5: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      formattedSrc: '',
      isSmallScreen: false
    }
  },
  created () {
  },
  mounted () {
    this.formattedSrc = this.res5.slice(24)
    // console.log(this.formattedSrc)
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  }
}
</script>
<style scoped lang="scss">
       .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    margin-left:18%;
    margin-right: 18%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    // width: 1116px;
    width: 85%;
    // height: 691px;
  }
@media screen and (min-width: 1920px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    margin-left: 375px;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 16px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    width: 1155px;
    // height: 728px;
  }
}
@media screen and (max-width: 1440px) and (min-width:1000px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    // margin-left: 155px;
    margin-left:18%;
    margin-right: 18%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    // width: 1116px;
    width: 85%;
    // height: 691px;
  }
}
@media screen and (max-width: 1000px) and (min-width:768px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    // margin-left: 155px;
    margin-left:5%;
    margin-right: 5%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    // width: 1116px;
    width: 85%;
    // height: 691px;
    // height: 603px;
    height: 100%;
  }
  .edits{
    width: 100%;
    height: 172px;
    display: flex;
    align-items: center;
    justify-content: center;
    .aedit{
      width: 123px;
      height: 118px;
      margin: 0 auto;
    }
    .p1{
      position: absolute;
      left: 135px;
      top: 1271px;
      color: #405c7f;
      font-weight: 800;
    }
    .p2{
      position: absolute;
      right: 165px;
      top: 1271px;
      color: #405c7f;
      font-weight: 800;
    }
    .p3{
      position: absolute;
      left: 159px;
      top: 1445px;
      color: #405c7f;
      font-weight: 800;
    }
    .p4{
      position: absolute;
      right: 165px;
      top: 1445px;
      color: #405c7f;
      font-weight: 800;
    }
  }
}
@media screen and (max-width:375px) {
    .industry{
    text-align: center;
    margin-top:73px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:24px ;
      color: #9a9a9a;
      margin-bottom: 32px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 25px;
    margin-right:25px ;
    .indus-chan{
      margin-top:45px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 319px;
    height: 100%;
  }
  .edits{
    width: 100%;
    height: 172px;
    display: flex;
    align-items: center;
    justify-content: center;
    .aedit{
      width: 123px;
      height: 118px;
      margin: 0 auto;
    }
    .p1{
      position: absolute;
      left: 38px;
      top: 856px;
      color: #405c7f;
      font-weight: 800;
    }
    .p2{
      position: absolute;
      right: 61px;
      top: 856px;
      color: #405c7f;
      font-weight: 800;
    }
    .p3{
      position: absolute;
      left: 63px;
      top: 1021px;
      color: #405c7f;
      font-weight: 800;
    }
    .p4{
      position: absolute;
      right: 61px;
      top: 1021px;
      color: #405c7f;
      font-weight: 800;
    }
  }
}
@media screen and (max-width:414px) and (min-width: 376px)  {
    .industry{
    text-align: center;
    margin-top:50px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:12px ;
      color: #9a9a9a;
      margin-bottom: 16px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 27px;
    margin-right: 25px ;
    margin-bottom:50px ;
    .indus-chan{
      margin-top:44px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 12px;
      }
    }
    .indus-chan1{
      margin-top: 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 319px;
    height: 100%;
  }
  .edits{
    width: 100%;
    height: 172px;
    display: flex;
    align-items: center;
    justify-content: center;
    .aedit{
      width: 123px;
      height: 118px;
      margin: 0 auto;
    }
    .p1{
      position: absolute;
      left: 38px;
      top: 856px;
      color: #405c7f;
      font-weight: 800;
    }
    .p2{
      position: absolute;
      right: 61px;
      top: 856px;
      color: #405c7f;
      font-weight: 800;
    }
    .p3{
      position: absolute;
      left: 63px;
      top: 1021px;
      color: #405c7f;
      font-weight: 800;
    }
    .p4{
      position: absolute;
      right: 61px;
      top: 1021px;
      color: #405c7f;
      font-weight: 800;
    }
  }
}
@media screen and (max-width:767px) and (min-width: 415px)  {
     .industry{
    text-align: center;
    margin-top:73px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:24px ;
      color: #9a9a9a;
      margin-bottom: 32px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 25px;
    margin-right:25px ;
    .indus-chan{
      margin-top:45px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 319px;
    height: 100%;
  }
  .edits{
    width: 100%;
    height: 172px;
    display: flex;
    align-items: center;
    justify-content: center;
    .aedit{
      width: 123px;
      height: 118px;
      margin: 0 auto;
    }
    .p1{
      position: absolute;
      left: 38px;
      top: 856px;
      color: #405c7f;
      font-weight: 800;
    }
    .p2{
      position: absolute;
      right: 61px;
      top: 856px;
      color: #405c7f;
      font-weight: 800;
    }
    .p3{
      position: absolute;
      left: 63px;
      top: 1021px;
      color: #405c7f;
      font-weight: 800;
    }
    .p4{
      position: absolute;
      right: 61px;
      top: 1021px;
      color: #405c7f;
      font-weight: 800;
    }
  }
}
</style>
